import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × PAPERCLUB PARIS: Print intimacy meets data structure
// Print grids, text alignment, type modularity
export function VasarelyPaperclubMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="paper-gradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FFFFF0" />
          <stop offset="50%" stopColor="#FFF8F0" />
          <stop offset="100%" stopColor="#FFF0E8" />
        </linearGradient>
        <pattern id="paper-lines" x="0" y="0" width="100%" height="25" patternUnits="userSpaceOnUse">
          <line x1="0" y1="24" x2="100%" y2="24" stroke="#E0E0D8" strokeWidth="1" />
        </pattern>
      </defs>

      {/* Paper white background */}
      <rect x="0" y="0" width="794" height="1123" fill="url(#paper-gradient)" />
      <rect x="0" y="0" width="794" height="1123" fill="url(#paper-lines)" />

      <g transform="translate(397 540)">
        {/* Print grids */}
        {Array.from({ length: 16 }).map((_, i) =>
          Array.from({ length: 22 }).map((_, j) => {
            const x = (i - 7.5) * 48;
            const y = (j - 10.5) * 48;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 22}
                y={y - 22}
                width="44"
                height="44"
                fill="none"
                stroke="#C0C0B8"
                strokeWidth="0.5"
                opacity="0.3"
              />
            );
          })
        )}

        {/* Text alignment guides */}
        {Array.from({ length: 8 }).map((_, i) => {
          const x = -280 + i * 80;
          return (
            <line
              key={`align-${i}`}
              x1={x}
              y1="-400"
              x2={x}
              y2="400"
              stroke="#D0D0C8"
              strokeWidth="1"
              opacity="0.25"
              strokeDasharray="5 5"
            />
          );
        })}

        {/* Type modularity blocks */}
        {[
          { x: -250, y: -300, w: 180, h: 40, text: "HEADLINE", size: 18 },
          { x: -250, y: -240, w: 220, h: 30, text: "Subheadline", size: 14 },
          { x: -250, y: -190, w: 500, h: 80, text: "Body Text", size: 10, lines: 6 },
          { x: -250, y: -90, w: 180, h: 40, text: "CALLOUT", size: 16 },
          { x: -250, y: -30, w: 500, h: 60, text: "Paragraph", size: 10, lines: 4 },
          { x: -250, y: 50, w: 140, h: 30, text: "Caption", size: 9 },
        ].map((block, i) => (
          <g key={i}>
            <rect
              x={block.x}
              y={block.y}
              width={block.w}
              height={block.h}
              fill="none"
              stroke="#A0A098"
              strokeWidth="1"
              opacity="0.3"
            />
            <text
              x={block.x + 10}
              y={block.y + block.h / 2 + 4}
              fontFamily="sans-serif"
              fontSize={block.size}
              fill="#707068"
              opacity="0.5"
            >
              {block.text}
            </text>
            {block.lines && Array.from({ length: block.lines }).map((_, j) => (
              <line
                key={j}
                x1={block.x + 10}
                y1={block.y + 10 + j * 12}
                x2={block.x + block.w - 10}
                y2={block.y + 10 + j * 12}
                stroke="#C0C0B8"
                strokeWidth="1"
                opacity="0.2"
              />
            ))}
          </g>
        ))}

        {/* Data structure circles */}
        {Array.from({ length: 10 }).map((_, i) => {
          const r = 60 + i * 26;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke="#A0A098"
              strokeWidth="1"
              opacity={0.25 - i * 0.02}
            />
          );
        })}

        {/* Central print module */}
        <rect x="-100" y="-100" width="200" height="200" fill="none" stroke="#707068" strokeWidth="2" />
        <rect x="-90" y="-90" width="180" height="180" fill="none" stroke="#A0A098" strokeWidth="1" />
        
        {/* Grid inside */}
        {Array.from({ length: 9 }).map((_, i) => {
          const offset = -80 + i * 20;
          return (
            <g key={i}>
              <line x1={offset} y1="-80" x2={offset} y2="80" stroke="#C0C0B8" strokeWidth="0.5" opacity="0.3" />
              <line x1="-80" y1={offset} x2="80" y2={offset} stroke="#C0C0B8" strokeWidth="0.5" opacity="0.3" />
            </g>
          );
        })}

        <text
          x="0"
          y="5"
          fontFamily="Courier, monospace"
          fontSize="14"
          fill="#707068"
          textAnchor="middle"
          fontWeight="600"
        >
          PAPER
        </text>
        <text
          x="0"
          y="25"
          fontFamily="Courier, monospace"
          fontSize="14"
          fill="#707068"
          textAnchor="middle"
          fontWeight="600"
        >
          CLUB
        </text>
      </g>

      {/* Print data structure */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="Courier, monospace" fontSize="9" fill="#707068" letterSpacing="2">
        ANALOG TACTILITY IN DIGITAL ORDER
      </text>
    </g>
  );
}
